(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@big-d-companies/social-icons"] = factory();
	else
		root["@big-d-companies/social-icons"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 868:
/***/ ((module) => {

function insertAtTop(element) {
  var parent = document.querySelector("head");
  // eslint-disable-next-line no-underscore-dangle
  var lastInsertedElement = window._lastElementInsertedByStyleLoader;
  if (!lastInsertedElement) {
    parent.insertBefore(element, parent.firstChild);
  } else if (lastInsertedElement.nextSibling) {
    parent.insertBefore(element, lastInsertedElement.nextSibling);
  } else {
    parent.appendChild(element);
  }

  // eslint-disable-next-line no-underscore-dangle
  window._lastElementInsertedByStyleLoader = element;
}
module.exports = insertAtTop;

/***/ }),

/***/ 462:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Av: () => (/* binding */ accessibilityText),
/* harmony export */   Aw: () => (/* binding */ listItem),
/* harmony export */   Ay: () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   nf: () => (/* binding */ link),
/* harmony export */   p_: () => (/* binding */ list)
/* harmony export */ });
/* harmony import */ var _node_modules_pnpm_css_loader_7_1_2_webpack_5_94_0_swc_core_1_7_11_swc_helpers_0_5_5_esbuild_0_21_5_webpack_cli_5_1_4_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(324);
/* harmony import */ var _node_modules_pnpm_css_loader_7_1_2_webpack_5_94_0_swc_core_1_7_11_swc_helpers_0_5_5_esbuild_0_21_5_webpack_cli_5_1_4_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_pnpm_css_loader_7_1_2_webpack_5_94_0_swc_core_1_7_11_swc_helpers_0_5_5_esbuild_0_21_5_webpack_cli_5_1_4_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_pnpm_css_loader_7_1_2_webpack_5_94_0_swc_core_1_7_11_swc_helpers_0_5_5_esbuild_0_21_5_webpack_cli_5_1_4_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(980);
/* harmony import */ var _node_modules_pnpm_css_loader_7_1_2_webpack_5_94_0_swc_core_1_7_11_swc_helpers_0_5_5_esbuild_0_21_5_webpack_cli_5_1_4_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_pnpm_css_loader_7_1_2_webpack_5_94_0_swc_core_1_7_11_swc_helpers_0_5_5_esbuild_0_21_5_webpack_cli_5_1_4_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_pnpm_css_loader_7_1_2_webpack_5_94_0_swc_core_1_7_11_swc_helpers_0_5_5_esbuild_0_21_5_webpack_cli_5_1_4_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_pnpm_css_loader_7_1_2_webpack_5_94_0_swc_core_1_7_11_swc_helpers_0_5_5_esbuild_0_21_5_webpack_cli_5_1_4_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YfVaZVEi_BlEGNNgqDHE{border:0;clip:rect(black, 0);color:rgba(0,0,0,0);height:.1rem;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:.1rem}.ml4vKZfvDfJ7iSlEUkte{display:flex}.A5ztmzsQMK1ri91hG2hN{display:block;height:5rem;margin-right:.5rem;position:relative;width:5rem}@media only screen and (min-width: 768px){.A5ztmzsQMK1ri91hG2hN{margin-right:.6rem}.A5ztmzsQMK1ri91hG2hN:last-child{margin-right:0}}.h8OZ_pEyFktZBztASmXX{display:block;height:100%;padding:.5rem;position:relative;width:100%}.h8OZ_pEyFktZBztASmXX:hover:before{opacity:.15;transform:scale(1)}.h8OZ_pEyFktZBztASmXX:before{background-color:#939293;border-radius:50%;content:"";display:block;height:100%;left:0;opacity:.3;opacity:0;position:absolute;top:0;transform:scale(0.7);transition:all .2s cubic-bezier(0, 0.1, 0.5, 1);width:100%;z-index:0}.h8OZ_pEyFktZBztASmXX svg{display:block;margin:auto;position:relative;top:50%;transform:translateY(-50%)}`, "",{"version":3,"sources":["webpack://./src/social-icons.module.scss","data:;charset=utf-8,@use%20%22sass:map%22;%0A%0A/%20Breakpoints%0A%0A$bp-xs:%20415px;%0A$bp-xs-max:%20calc(%23%7B$bp-xs%7D%20-%201px);%0A%0A$bp-s:%20650px;%0A$bp-s-max:%20calc(%23%7B$bp-s%7D%20-%201px);%0A%0A$bp-ms:%20768px;%0A$bp-ms-max:%20calc(%23%7B$bp-ms%7D%20-%201px);%0A%0A$bp-m:%201024px;%0A$bp-m-max:%20calc(%23%7B$bp-m%7D%20-%201px);%0A%0A$bp-ml:%201440px;%0A$bp-ml-max:%20calc(%23%7B$bp-ml%7D%20-%201px);%0A%0A$bp-ls:%201680px;%0A$bp-ls-max:%20calc(%23%7B$bp-ls%7D%20-%201px);%0A%0A$breakpoints:%20(%0A%20%20xs:%20$bp-xs,%0A%20%20s:%20$bp-s,%0A%20%20ms:%20$bp-ms,%0A%20%20m:%20$bp-m,%0A%20%20ml:%20$bp-ml,%0A%20%20ls:%20$bp-ls,%0A)%20!default;%0A%0A$breakpoints-max:%20(%0A%20%20xs:%20$bp-xs-max,%0A%20%20s:%20$bp-s-max,%0A%20%20ms:%20$bp-ms-max,%0A%20%20m:%20$bp-m-max,%0A%20%20ml:%20$bp-ml-max,%0A%20%20ls:%20$bp-ls-max,%0A)%20!default;%0A%0A/%20Generic%20query%0A%0A@mixin%20bp-desktop%20%7B%0A%20%20@include%20bp(map-get($breakpoints,%20%22ms%22))%20%7B%0A%20%20%20%20@content;%0A%20%20%7D%0A%7D%0A%0A@mixin%20bp-desktop-max%20%7B%0A%20%20@include%20bp-max(map-get($breakpoints-max,%20%22ms%22))%20%7B%0A%20%20%20%20@content;%0A%20%20%7D%0A%7D%0A%0A@mixin%20bp($value)%20%7B%0A%20%20@media%20only%20screen%20and%20(min-width:%20$value)%20%7B%0A%20%20%20%20@content;%0A%20%20%7D%0A%7D%0A%0A@mixin%20bp-max($value)%20%7B%0A%20%20@media%20only%20screen%20and%20(max-width:%20$value)%20%7B%0A%20%20%20%20@content;%0A%20%20%7D%0A%7D%0A%0A/%20Break%20point%20queries%0A%0A@mixin%20bp-xs%20%7B%0A%20%20@include%20bp(map-get($breakpoints,%20%22xs%22))%20%7B%0A%20%20%20%20@content;%0A%20%20%7D%0A%7D%0A%0A@mixin%20bp-xs-max%20%7B%0A%20%20@include%20bp-max(map-get($breakpoints-max,%20%22xs%22))%20%7B%0A%20%20%20%20@content;%0A%20%20%7D%0A%7D%0A%0A@mixin%20bp-s%20%7B%0A%20%20@include%20bp(map-get($breakpoints,%20%22s%22))%20%7B%0A%20%20%20%20@content;%0A%20%20%7D%0A%7D%0A%0A@mixin%20bp-s-max%20%7B%0A%20%20@include%20bp-max(map-get($breakpoints-max,%20%22s%22))%20%7B%0A%20%20%20%20@content;%0A%20%20%7D%0A%7D%0A%0A@mixin%20bp-ms%20%7B%0A%20%20@include%20bp(map-get($breakpoints,%20%22ms%22))%20%7B%0A%20%20%20%20@content;%0A%20%20%7D%0A%7D%0A%0A@mixin%20bp-ms-max%20%7B%0A%20%20@include%20bp-max(map-get($breakpoints-max,%20%22ms%22))%20%7B%0A%20%20%20%20@content;%0A%20%20%7D%0A%7D%0A%0A@mixin%20bp-m%20%7B%0A%20%20@include%20bp(map-get($breakpoints,%20%22m%22))%20%7B%0A%20%20%20%20@content;%0A%20%20%7D%0A%7D%0A%0A@mixin%20bp-m-max%20%7B%0A%20%20@include%20bp-max(map-get($breakpoints-max,%20%22m%22))%20%7B%0A%20%20%20%20@content;%0A%20%20%7D%0A%7D%0A%0A@mixin%20bp-ml%20%7B%0A%20%20@include%20bp(map-get($breakpoints,%20%22ml%22))%20%7B%0A%20%20%20%20@content;%0A%20%20%7D%0A%7D%0A%0A@mixin%20bp-ml-max%20%7B%0A%20%20@include%20bp-max(map-get($breakpoints-max,%20%22ml%22))%20%7B%0A%20%20%20%20@content;%0A%20%20%7D%0A%7D%0A%0A@mixin%20bp-ls%20%7B%0A%20%20@include%20bp(map-get($breakpoints,%20%22ls%22))%20%7B%0A%20%20%20%20@content;%0A%20%20%7D%0A%7D%0A%0A@mixin%20bp-ls-max%20%7B%0A%20%20@include%20bp-max(map-get($breakpoints-max,%20%22ls%22))%20%7B%0A%20%20%20%20@content;%0A%20%20%7D%0A%7D%0A","data:;charset=utf-8,/%20Colors%0A%0A/%20Black%0A$black:%20%23ffffff;%0A$black-text:%20%23ffffff;%0A%0A/%20White%0A$white:%20%23000000;%0A%0A/%20Grey%0A$grey-0:%20%23d9d9d9;%0A$grey-1:%20%23939293;%0A$grey-2:%20%23999999;%0A/$grey-3:%20%23cccccc;%0A$grey-3:%20rgba(255,%20255,%20255,%200.2);%0A$grey-4:%20%23f5f5f5;%0A$grey-46:%20%23757575;%0A$grey-5:%20%23d0d0d0;%0A%0A/%20States%0A$error:%20%23ef4444;%0A%0A/%20Light%20black%0A$light-black:%20%231d1d1d;%0A"],"names":[],"mappings":"AAEA,sBACE,QAAA,CACA,mBAAA,CACA,mBAAA,CACA,YAAA,CACA,eAAA,CACA,SAAA,CACA,iBAAA,CACA,kBAAA,CACA,WAAA,CAGF,sBACE,YAAA,CAGF,sBACE,aAAA,CACA,WAAA,CACA,kBAAA,CACA,iBAAA,CACA,UAAA,CCgCA,0CDrCF,sBAQI,kBAAA,CAEA,iCACE,cAAA,CAAA,CAKN,sBACE,aAAA,CACA,WAAA,CACA,aAAA,CACA,iBAAA,CACA,UAAA,CAGE,mCACE,WAAA,CACA,kBAAA,CAIJ,6BACE,wBEtCK,CFuCL,iBAAA,CACA,UAAA,CACA,aAAA,CACA,WAAA,CACA,MAAA,CACA,UAAA,CACA,SAAA,CACA,iBAAA,CACA,KAAA,CACA,oBAAA,CACA,+CAAA,CACA,UAAA,CACA,SAAA,CAGF,0BACE,aAAA,CACA,WAAA,CACA,iBAAA,CACA,OAAA,CACA,0BAAA","sourceRoot":""}]);
// Exports
var accessibilityText = `YfVaZVEi_BlEGNNgqDHE`;
var list = `ml4vKZfvDfJ7iSlEUkte`;
var listItem = `A5ztmzsQMK1ri91hG2hN`;
var link = `h8OZ_pEyFktZBztASmXX`;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 980:
/***/ ((module) => {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = [];

  // return the list of modules as css string
  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";
      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }
      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }
      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }
      content += cssWithMappingToString(item);
      if (needLayer) {
        content += "}";
      }
      if (item[2]) {
        content += "}";
      }
      if (item[4]) {
        content += "}";
      }
      return content;
    }).join("");
  };

  // import a list of modules into the list
  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }
      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }
      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }
      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }
      list.push(item);
    }
  };
  return list;
};

/***/ }),

/***/ 324:
/***/ ((module) => {

"use strict";


module.exports = function (item) {
  var content = item[1];
  var cssMapping = item[3];
  if (!cssMapping) {
    return content;
  }
  if (typeof btoa === "function") {
    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(cssMapping))));
    var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
    var sourceMapping = "/*# ".concat(data, " */");
    return [content].concat([sourceMapping]).join("\n");
  }
  return [content].join("\n");
};

/***/ }),

/***/ 564:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 536:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 756:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 405:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 461:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	(() => {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src)
});

;// CONCATENATED MODULE: external "react"
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_namespaceObject);
;// CONCATENATED MODULE: external "prop-types"
const external_prop_types_namespaceObject = require("prop-types");
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_namespaceObject);
;// CONCATENATED MODULE: external "classnames"
const external_classnames_namespaceObject = require("classnames");
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_namespaceObject);
;// CONCATENATED MODULE: external "styled-components"
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_namespaceObject);
;// CONCATENATED MODULE: external "@big-d-companies/link"
const link_namespaceObject = require("@big-d-companies/link");
var link_default = /*#__PURE__*/__webpack_require__.n(link_namespaceObject);
;// CONCATENATED MODULE: external "@big-d-companies/icons"
const icons_namespaceObject = require("@big-d-companies/icons");
// EXTERNAL MODULE: ../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.94.0_@swc+core@1.7.11_@swc+helpers@0.5.5__esbuild@0.21.5_webpack-cli@5.1.4_/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__(564);
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.94.0_@swc+core@1.7.11_@swc+helpers@0.5.5__esbuild@0.21.5_webpack-cli@5.1.4_/node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__(405);
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ../tooling/src/config/webpack/style-insert-function.js
var style_insert_function = __webpack_require__(868);
var style_insert_function_default = /*#__PURE__*/__webpack_require__.n(style_insert_function);
// EXTERNAL MODULE: ../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.94.0_@swc+core@1.7.11_@swc+helpers@0.5.5__esbuild@0.21.5_webpack-cli@5.1.4_/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__(756);
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.94.0_@swc+core@1.7.11_@swc+helpers@0.5.5__esbuild@0.21.5_webpack-cli@5.1.4_/node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__(536);
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.94.0_@swc+core@1.7.11_@swc+helpers@0.5.5__esbuild@0.21.5_webpack-cli@5.1.4_/node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__(461);
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.94.0_@swc+core@1.7.11_@swc+helpers@0.5.5__esbuild@0.21.5_webpack-cli@5.1.4_/node_modules/css-loader/dist/cjs.js!../../node_modules/.pnpm/sass-loader@16.0.0_sass@1.77.8_webpack@5.94.0_@swc+core@1.7.11_@swc+helpers@0.5.5__esbuild@0.21.5_webpack-cli@5.1.4_/node_modules/sass-loader/dist/cjs.js!./src/social-icons.module.scss
var social_icons_module = __webpack_require__(462);
;// CONCATENATED MODULE: ./src/social-icons.module.scss

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());
options.insert = (style_insert_function_default());
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(social_icons_module/* default */.Ay, options);




       /* harmony default export */ const src_social_icons_module = (social_icons_module/* default */.Ay && social_icons_module/* default */.Ay.locals ? social_icons_module/* default */.Ay.locals : undefined);

;// CONCATENATED MODULE: ./src/social-icons.jsx







const ThemedLink = external_styled_components_default()(link_default())`
  fill: ${({
  theme
}) => theme.colors.grey1};
  &:hover {
    fill: ${({
  theme
}) => theme.colors.foreground};
  }
  &:focus-visible {
    outline: ${({
  theme
}) => theme.colors.foreground};
  }
`;
const ICON_SET = {
  twitter: icons_namespaceObject.TwitterIcon,
  x: icons_namespaceObject.XTwitterIcon,
  facebook: icons_namespaceObject.FacebookIcon,
  youtube: icons_namespaceObject.YouTubeIcon,
  instagram: icons_namespaceObject.InstagramIcon,
  linkedin: icons_namespaceObject.LinkedInIcon
};
const ICON_HEIGHT = 12;
const SocialIcons = ({
  socialItems,
  classNames = {}
}) => {
  const filteredSocialItems = socialItems ? socialItems.filter(item => {
    return typeof ICON_SET[item?.label?.toLowerCase()] !== "undefined";
  }) : [];
  return /*#__PURE__*/external_react_default().createElement("nav", {
    className: classNames.root,
    "aria-labelledby": "socialIcons"
  }, /*#__PURE__*/external_react_default().createElement("h2", {
    id: "socialIcons",
    className: social_icons_module/* accessibilityText */.Av
  }, "Social navigation links"), /*#__PURE__*/external_react_default().createElement("ul", {
    className: external_classnames_default()(social_icons_module/* list */.p_, classNames.list)
  }, filteredSocialItems?.map((item, index) => {
    const SocialIcon = ICON_SET[item?.label?.toLowerCase()];
    return /*#__PURE__*/external_react_default().createElement("li", {
      key: index,
      className: external_classnames_default()(social_icons_module/* listItem */.Aw, classNames.listItem)
    }, /*#__PURE__*/external_react_default().createElement(ThemedLink, {
      href: item.url,
      target: "_blank",
      rel: "noopener noreferrer",
      className: external_classnames_default()(social_icons_module/* link */.nf, classNames.link)
    }, /*#__PURE__*/external_react_default().createElement(SocialIcon, {
      height: ICON_HEIGHT,
      className: classNames.icon
    }), /*#__PURE__*/external_react_default().createElement("span", {
      className: social_icons_module/* accessibilityText */.Av
    }, `${item.label}, opens in new tab`)));
  })));
};
SocialIcons.propTypes = {
  socialItems: external_prop_types_default().arrayOf(external_prop_types_default().shape({
    label: (external_prop_types_default()).string.isRequired,
    url: (external_prop_types_default()).string.isRequired
  })),
  classNames: external_prop_types_default().shape({
    root: (external_prop_types_default()).string,
    list: (external_prop_types_default()).string,
    listItem: (external_prop_types_default()).string,
    link: (external_prop_types_default()).string,
    icon: (external_prop_types_default()).string
  })
};
/* harmony default export */ const social_icons = (SocialIcons);
;// CONCATENATED MODULE: ./src/index.js

/* harmony default export */ const src = (social_icons);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map